import { combineReducers } from '@reduxjs/toolkit';

import PrincipalSlice from '../features/principal/PrincipalSlice'
import distributorReconSlice from '../features/distributor/DistributorReconSlice'
import distributorSlice from '../features/distributor/DistributorSlice'
import dashboardSlice from '../features/dashboard/DashboardSlice'

import TenantSlice from '../features/outlet/TenantSlice'
import VpaSlice from '../features/vpa/VpaSlice'
import PreauthVpaSlice from '../features/preauthVpa/PreauthVpaSlice'
import ProgramSlice from '../features/program/ProgramSlice'
import UtrSlice from '../features/outlet/UtrSlice'
import NotificationSlice from '../features/notification/NotificationSlice'

const rootReducer = combineReducers({
  distributorRecon: distributorReconSlice,
  distributor: distributorSlice,
  dashboard: dashboardSlice,
  
  principal: PrincipalSlice,
  vpa: VpaSlice,
  preauthVpa: PreauthVpaSlice,
  tenant: TenantSlice,
  program: ProgramSlice,
  utr: UtrSlice,
  notification: NotificationSlice
});

export default rootReducer;
